exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge {\n  padding: 0.6rem 0.7rem;\n  margin: 3px 5px;\n  border-radius: 4px;\n  position: relative;\n  overflow: hidden;\n}\n.badge .icon {\n  margin-right: 5px;\n}\n.badge.medium {\n  padding: 0.4rem 0.5rem;\n}\n.badge.no-margin {\n  margin: 0;\n}\n.badge.hoverable:hover {\n  cursor: pointer;\n}\n.badge .close-icon {\n  font-size: 1.6em;\n  line-height: 0.1;\n  vertical-align: sub;\n  margin-left: 2px;\n  padding-left: 2px;\n}\n", ""]);

// exports
